function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import browser from '../browser';
export default {
  name: 'CollapseTransition',
  methods: {
    onEnter: function onEnter(el) {
      var nEl = el;

      var _getComputedStyle = getComputedStyle(nEl),
          width = _getComputedStyle.width;

      nEl.style.width = width;
      nEl.style.position = 'absolute'; // firefox 有bug,貌似会渲染两次...,先注释掉
      // nEl.style.visibility = 'hidden';

      nEl.style.height = 'auto';

      var _getComputedStyle2 = getComputedStyle(nEl),
          height = _getComputedStyle2.height;

      nEl.style.width = '';
      nEl.style.position = '';
      nEl.style.visibility = '';
      nEl.style.height = 0;
      setTimeout(function () {
        nEl.style.height = height;
        setTimeout(function () {
          nEl.style.opacity = 1;
        }, 10);
      }, 10);
    },
    onAfterEnter: function onAfterEnter(el) {
      var nEl = el;
      nEl.style.height = '';
      nEl.style.opacity = '';
    },
    onBeforeLeave: function onBeforeLeave(el) {
      el.style.opacity = 0;
    },
    onLeave: function onLeave(el) {
      var nEl = el;

      var _getComputedStyle3 = getComputedStyle(nEl),
          height = _getComputedStyle3.height;

      nEl.style.height = height;
      nEl.style.opacity = 0;
      setTimeout(function () {
        nEl.style.height = 0;
      }, 10);
    },
    onAfterLeave: function onAfterLeave(el) {
      var nEl = el;
      nEl.style.height = '';
      nEl.style.opacity = '';
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        onEnter = this.onEnter,
        onAfterEnter = this.onAfterEnter,
        onLeave = this.onLeave,
        onAfterLeave = this.onAfterLeave,
        onBeforeLeave = this.onBeforeLeave;
    return browser.isIE9 ? h("div", [$slots.default]) : h("transition", {
      "props": _objectSpread({}, {
        name: 'ux-motion-collapse'
      }),
      "on": _objectSpread({}, {
        enter: onEnter,
        afterEnter: onAfterEnter,
        beforeLeave: onBeforeLeave,
        leave: onLeave,
        afterLeave: onAfterLeave
      })
    }, [$slots.default]);
  }
};